<div class="RegisterStepReceipt">
  <div class="container py-3">
    <div class="RegisterStepReceipt-header row">
      <div class="col col-12 d-flex flex-row justify-content-between">
        <span class="text-center text-sm-right mb-0"><strong>Name of Card:</strong> {{paymentData.payment_data.card_name}}</span>
        <span class="text-center text-sm-right mb-0"><strong>Brand: </strong>{{paymentData.payment_data.card_brand}}</span>
        <span class="text-center text-sm-right mb-0"><strong>Card Number:</strong> {{generateCardNumber()}}</span>
      </div>
    </div>
  </div>
  <div class="RegisterStepReceipt-details w-100 py-5">
    <div class="RegisterStepReceipt-details-container container py-5">
        <div class="RegisterStepReceipt-details-container-header row-fluid">
          <h3>Plan Details</h3>
        </div>
        <div class="RegisterStepReceipt-details-container-body row-fluid pt-0 pt-sm-3">
          <div class="col col-12">
            <div class="d-flex flex-column flex-sm-row">
              <div class="flex-grow-1">
                <div class="RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3">
                  <p class="text-left"><strong>Name: </strong>Retreva</p>
                </div>
                <div class="RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3">
                  <p class="text-left"><strong>Price: </strong>$249/mo</p>
                </div>
                <div class="RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-3">
                  <p class="text-left"><strong>Email: </strong>{{paymentData.payment_data.client_email}}</p>
                </div>
                <div class="RegisterStepReceipt-details-container-body-row d-block pr-0 pr-sm-5 pt-4">
                  <p class="text-left"><strong>Plan Trial Days: </strong>{{paymentData.payment_data.plan_trial}}</p>
                </div>
              </div>
              <div class="flex-grow-1">
                <div *ngIf="paymentData.payment_data.payment_amount" class="RegisterStepReceipt-details-container-body-row d-block pt-3">
                  <p class="text-left"><strong>One Time Fee: </strong>{{paymentData.payment_data.payment_amount}}</p>
                </div>
                <div *ngIf="paymentData.payment_data.payment_recurring" class="RegisterStepReceipt-details-container-body-row d-block pt-4">
                  <p class="text-left"><strong>Recurring Fee: </strong>{{paymentData.payment_data.payment_recurring}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="RegisterStepReceipt-info w-100 py-5">
    <div class="container">
      <div class="d-flex flex-row flex-sm-row justify-content-between">
        <div class="d-flex flex-column flex-sm-column align-bottom">
          <p><strong>Address: </strong>3767 Attucks Drive Powell, OH 43065</p>
          <p><strong>Phone: </strong>614.902.3400</p>
          <p class="mb-0"><strong>Email: </strong>help@retreva.com</p>
        </div>
        <div class="d-flex flex-column flex-sm-column align-bottom">
          <p><strong>Customer Name: {{paymentData.payment_data.client_first_name}} {{paymentData.payment_data.client_last_name}}</strong></p>
          <p><strong>Address: </strong>{{paymentData.payment_data.client_address}}</p>
          <p><strong>Phone: </strong>{{paymentData.payment_data.client_phone}}</p>
          <p class="mb-0"><strong>Email: </strong>{{paymentData.payment_data.client_email}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row-fluid pt-5">
    <div class="col col-12">
      <app-button [text]="'Continue'" [Click]="onContinue" [color]="'orange'" [size]="'normal'" [style]="'rounded'"></app-button>
    </div>
  </div>
</div>
